export default __webpack_public_path__ + "static/media/i-dots-hor.660aba27.svg";